module.exports = __webpack_public_path__ + "fonts/NotoSans-Regular.53e1309e.woff";